import React, { Component } from 'react';

import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade } from 'react-bootstrap';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { AutoAffix } from 'react-overlays';

import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';

export default class SpoiledTomatillosBlurb extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h3>Spoiled Tomatillos</h3>
                <p className='blurb-text'>
                  Spoiled Tomatillos was a semester-long project for my Software Development course at Northeastern University. With 4 of my classmates, we developed a web application similar to the movie review website, Rotten Tomatoes.
                </p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SpoiledTomatillosBlurb.jsx